import { useEffect, memo, useState, useRef } from 'react';
import { useRouter } from 'next/router';
import moment from 'moment';
import styles from './index.module.scss';
import LeftMenu from './LeftMenu';
import { getDownloadCatagoryTree, getDownloadInfo } from '@/service';
import CustomSpin from '@/components/UI/CustomSpin';
import { useGlobal } from '@/utils/useGlobal';
import Empty from '@/components/Search/Empty';
import useEFPic from '@/utils/useEFPic';
import { Pagination } from '@/components/UI';

const ChildComp = () => {
    const { locale } = useRouter();
    const { Link, useLang } = useGlobal();
    const { t } = useLang('shared');
    const { t: s } = useLang('supportdownloadproduct');
    const [menuData, setMenuData] = useState([]);
    const [fileList, setFileList] = useState([]);
    const [loading, setLoading] = useState(false);
    const allKeys = useRef('1514858700785975298');
    const oldKey = useRef('');
    const curKeyName = useRef('productCatagoryIds');
    const powerKitsId = '1514858700785975298';
    const { EFPic } = useEFPic('/media/support-download-index/pc/');
    const iconMap = {
        pdf: {
            fileIcon: <EFPic className="fileIcon" name={[`file-icon.webp`, `file-icon.png`]} alt={t('support.download.file_icon')} />,
        },
        video: {
            fileIcon: <EFPic className="fileIcon" name={[`file-icon.webp`, `file-icon.png`]} alt={t('support.download.file_icon')} />,
        },
    };
    const [pageInfo, setPageInfo] = useState({
        page: 1,
        total: 0,
        size: 9,
    });

    // 获取左边树结构，只需要power kits的数据
    const getMenuData = async () => {
        try {
            const res = await getDownloadCatagoryTree(locale as string);
            if (res.code === '0') {
                const data = res.data.filter((item: Record<string, any>) => item.downloadCatagoryId === powerKitsId);
                setMenuData(data);
                return data;
            }
        } catch (e) {
            setMenuData([]);
            return [];
        }
    };

    // 根据根据选择左边树菜单的id，获取右边下载文件的列表
    const getDataList = async (id: string | number, keyName?: string, page = 1) => {
        console.log(page);
        setLoading(true);
        const params: Record<string, string | number> = { size: 9, page: page || pageInfo.page };
        curKeyName.current = keyName || 'productCatagoryIds';
        oldKey.current = id as string;
        params[keyName || 'productCatagoryIds'] = id;
        try {
            const res = await getDownloadInfo({ ...params });
            if (res.code === '0') {
                setPageInfo({ size: 9, page: page || 1, total: res.data?.total || 0 });
                setFileList(res.data.content || []);
            }
            setLoading(false);
        } catch (e) {
            setLoading(false);
            setFileList([]);
        }
    };

    const handlePageChange = (page: number) => {
        const params = pageInfo;
        setPageInfo({ ...params, page });
        getDataList(oldKey.current, curKeyName.current, page).catch(console.error);
    };

    const handleSelect = ({ key }: { key: string }) => {
        getDataList(key, 'spuIds').catch(console.error);
    };
    const onTitleClick = ({ key }: { key: string }) => {
        if (oldKey.current !== key) {
            let ids = '';
            if (key === powerKitsId) {
                (menuData as any[])[0]?.subs.forEach((item: Record<string, any>) => {
                    ids += `,${item.downloadCatagoryId}`;
                });
                oldKey.current = key + ids;
            } else {
                oldKey.current = key;
            }
            getDataList(oldKey.current).catch(console.error);
        }
    };

    useEffect(() => {
        getMenuData().then((data) => {
            let ids = '';
            (data as any[])[0]?.subs.forEach((item: Record<string, any>) => {
                ids += `,${item.downloadCatagoryId}`;
            });
            allKeys.current = allKeys.current + ids;
            getDataList(allKeys.current).catch(console.error);
        });
    }, []);

    return (
        <div className={styles.powerKitsDownload}>
            <div className="left-box">
                <LeftMenu data={menuData} onSelect={handleSelect} onTitleClick={onTitleClick} />
            </div>
            <div className="right-box">
                <ul className="fileList">
                    <CustomSpin loading={loading} customStyle={{ position: 'relative', top: '30px' }} />
                    {Array.isArray(fileList) &&
                        fileList?.length > 0 &&
                        fileList?.map((file: Record<string, any>) => (
                            <li className="fileItem" key={file.downloadInfoId} style={{ opacity: !loading ? 1 : 0 }}>
                                <div className="file-icon">{file.classify === 'MANUAL' ? iconMap.pdf.fileIcon : iconMap.video.fileIcon}</div>
                                <div className="content">
                                    <p className="desc font-family-medium">{file.title}</p>
                                    <p className="time font-family-medium">{moment(file.updateTime).format('YYYY-MM-DD')}</p>
                                    <Link href={file.fileUrl} ariaLabel={file.classify === 'MANUAL' ? s('Download PDF') : s('Play video')}>
                                        <span className="download-btn font-family-semibold">
                                            {file.classify === 'MANUAL' ? <span className="pdfDownload"></span> : <span className="videoDownload"></span>}
                                            {file.classify === 'MANUAL' ? 'PDF' : 'Video'}
                                        </span>
                                    </Link>
                                </div>
                            </li>
                        ))}
                    {Array.isArray(fileList) && fileList?.length > 0 && (
                        <div className="page-content">
                            <Pagination
                                className="page"
                                current={pageInfo.page}
                                pageSize={pageInfo.size}
                                total={pageInfo.total}
                                hideOnSinglePage={true}
                                showSizeChanger={false}
                                onChange={handlePageChange}
                            />
                        </div>
                    )}
                </ul>
                {/* 无数据情况  */}
                {(!Array.isArray(fileList) || fileList.length === 0) && <Empty style={{ marginBottom: 0 }} />}
            </div>
        </div>
    );
};

const ChildMemo = memo(ChildComp);

export default function Download() {
    return (
        <div className={styles.powerKitsDownload}>
            <ChildMemo />
        </div>
    );
}
